import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

export const deskopMediaQuery = '(min-width: 1224px)';
export const smallMobileQuery = '(min-width: 560px)';
export const mobileLandscape = '(min-width: 0px) and (max-width: 932px) and (max-height: 430px) and (orientation: landscape) and (pointer: coarse)';
export function useIsMobile() {
    const isDesktopOrLaptop = useMediaQuery({
        query: deskopMediaQuery,
    });
    return !isDesktopOrLaptop;
}
export function useIsSmallMobile() {
    const isSmallMobileQuery = useMediaQuery({
        query: smallMobileQuery,
    });
    return !isSmallMobileQuery;
}
export function useIsLandscapeOnMobile() {
    const isSmallMobileLandscapeQuery = useMediaQuery({
        query: mobileLandscape,
    });
    return isSmallMobileLandscapeQuery;
}
export function useReponsiveSwitch<T>(isMobile: boolean, desktopValue: T, mobileValue: T) {
    const value = useMemo(() => (isMobile ? mobileValue : desktopValue), [isMobile, desktopValue, mobileValue]);
    return value;
}

export function useReponsive<T>(desktopValue: T, mobileValue: T) {
    const isMobile = useIsMobile();
    return { isMobile, value: useReponsiveSwitch(isMobile, desktopValue, mobileValue) };
}
